"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const HomeStore_1 = require("../stores/HomeStore");
class CustomActions {
    static GetMapLocs(context, payload, callback) {
        context.service.read('mapLocs', {}, {}, function (err, result) {
            context.dispatch(HomeStore_1.HOME_OPEN_MAP, result);
            callback();
        });
    }
}
exports.default = CustomActions;
